import {ExportCarePlanTableColumnStyle} from '../../base/export-care-plan-types';
import {CommonBadlPdfDataProcessor} from '../export-care-plan-common-badl-pdf-data';

export class FoodPdfDataProcessor extends CommonBadlPdfDataProcessor {
  // Inherits the same headers and row structure as Common processor.

  override resolveDetailsColumnStyles(
    detailsHeaders: string[]
  ): ExportCarePlanTableColumnStyle | undefined {
    return this.createColumnStyles(detailsHeaders, 30);
  }
}
